import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { isEmpty } from 'lodash/fp';
import { LocalizedText, withScopeContext } from '@mews/framework';
import { ApplicationState } from '@mews-commander/types';
import { TextKey } from '@mews-commander/enums';
import { getServiceAdditionalItemsKeys, AdditionalOrderItemType } from '../../../../../selectors';
import { SummaryRow, NoItems } from '../../SummaryRow';
import AdditionalItemList from './AdditionalItemList';

interface StateProps {
    additionalItemKeys: AdditionalOrderItemType[];
}

interface OwnProps {
    scope: string;
    serviceId: string;
}

type AdditionalItemsProps = StateProps & OwnProps;

const AdditionalItems = ({ additionalItemKeys, serviceId }: AdditionalItemsProps) => (
    <SummaryRow
        label={<LocalizedText textKey={TextKey.AdditionalExpense} />}
        body={
            isEmpty(additionalItemKeys) ? (
                <NoItems />
            ) : (
                <AdditionalItemList additionalItemKeys={additionalItemKeys} serviceId={serviceId} />
            )
        }
    />
);

export default withScopeContext(
    connect(
        createStructuredSelector<ApplicationState, OwnProps, StateProps>({
            additionalItemKeys: getServiceAdditionalItemsKeys,
        })
    )(AdditionalItems)
);
